import { FeatureFlagService } from '../../../_shared/services/feature-flag.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap, switchMap } from 'rxjs/operators';
import { UserService } from '../user.service';
import { ApiService } from '../../../_shared/services/api.service';
import { CardService } from '../card.service';
import { CardType } from '../../../_shared/models/card-models/CardType';

@Injectable({
  providedIn: 'root'
})
export class NewcardtypeGuard {
  private apiService = inject(ApiService);
  private userService = inject(UserService);
  private cardService = inject(CardService);
  private featureFlagService = inject(FeatureFlagService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const trackId = route.params['trackId'];

    return this.cardService.getCurrentCard().pipe(
      switchMap(card => {
        if (card && card.trackId) {
          return of(card);
        } else {
          // If no card data, fetch from API
          return this.apiService.getCustomer(trackId).pipe(
            tap(account => {
              this.userService.setUser(account);
              this.userService.setAccount(account?.accountDetails);
            }),
            switchMap(() => this.cardService.getCurrentCard())
          );
        }
      }),
      map(card => {
        if (!card || card.path === '') {
          return this.router.createUrlTree(['/error']);
        }
        const cardType = this.mapCardPathToCardType(card.path);

        this.featureFlagService.setShowNewDesign(cardType === 12);
        // If it's a GMB card, allow access to GMB routes
        if (cardType === 12) {
          return true;
        }

        // If it's not a GMB card, redirect to the non-GMB summary route
        return this.router.createUrlTree(['/']);
      }),
      catchError(error => {
        console.error('Error fetching user data:', error);
        return of(this.router.createUrlTree(['/error']));
      })
    );
  }

  private mapCardPathToCardType(cardPath: string): CardType {
    return cardPath === 'gmb' ? 12 : 13;
  }
}
